(function () {
  'use strict';

  function initializeCollectionSlider(section) {
    if (!section || section.dataset.pcsInitialized === 'true') {
      return;
    }

    const slider = section.querySelector('[data-pcs-slider]');
    const cards = Array.from(
      section.querySelectorAll('[data-pcs-card]')
    );

    const previousButtons = Array.from(
      section.querySelectorAll('[data-pcs-prev]')
    );

    const nextButtons = Array.from(
      section.querySelectorAll('[data-pcs-next]')
    );

    const dotsContainer = section.querySelector('[data-pcs-dots]');

    if (!slider || cards.length === 0) {
      return;
    }

    section.dataset.pcsInitialized = 'true';

    let currentPage = 0;
    let cardsPerPage = 1;
    let totalPages = 1;
    let dots = [];
    let scrollTicking = false;
    let resizeTimer = null;

    function isRTL() {
      return window.getComputedStyle(section).direction === 'rtl';
    }

    function getGap() {
      const sliderStyles = window.getComputedStyle(slider);
      const gap = parseFloat(
        sliderStyles.columnGap || sliderStyles.gap || '0'
      );

      return Number.isFinite(gap) ? gap : 0;
    }

    function calculateCardsPerPage() {
      const firstCard = cards[0];

      if (!firstCard) {
        return 1;
      }

      const cardWidth = firstCard.getBoundingClientRect().width;
      const sliderWidth = slider.getBoundingClientRect().width;
      const gap = getGap();

      if (cardWidth <= 0 || sliderWidth <= 0) {
        return 1;
      }

      return Math.max(
        1,
        Math.round(
          (sliderWidth + gap) / (cardWidth + gap)
        )
      );
    }

    function createDots() {
      if (!dotsContainer) {
        return;
      }

      dotsContainer.innerHTML = '';

      const dotLabel =
        dotsContainer.dataset.dotLabel || 'Show product group';

      for (let index = 0; index < totalPages; index += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'pcs-dot';

        dot.setAttribute(
          'aria-label',
          `${dotLabel} ${index + 1}`
        );

        dot.addEventListener('click', function () {
          goToPage(index);
        });

        dotsContainer.appendChild(dot);
      }

      dots = Array.from(
        dotsContainer.querySelectorAll('.pcs-dot')
      );
    }

    function updateControls() {
      const hasMultiplePages = totalPages > 1;

      section.classList.toggle(
        'pcs-no-controls',
        !hasMultiplePages
      );

      dots.forEach(function (dot, index) {
        const isActive = index === currentPage;

        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      previousButtons.forEach(function (button) {
        button.disabled = currentPage <= 0;
      });

      nextButtons.forEach(function (button) {
        button.disabled = currentPage >= totalPages - 1;
      });
    }

    function goToPage(pageIndex, behavior) {
      const safePage = Math.max(
        0,
        Math.min(pageIndex, totalPages - 1)
      );

      currentPage = safePage;

      const targetCard = cards[currentPage * cardsPerPage];

      if (targetCard) {
        targetCard.scrollIntoView({
          behavior: behavior || 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      updateControls();
    }

    function detectCurrentPage() {
      const sliderRect = slider.getBoundingClientRect();
      const rtl = isRTL();

      const sliderStart = rtl
        ? sliderRect.right
        : sliderRect.left;

      let nearestPage = 0;
      let nearestDistance = Infinity;

      for (
        let pageIndex = 0;
        pageIndex < totalPages;
        pageIndex += 1
      ) {
        const card = cards[pageIndex * cardsPerPage];

        if (!card) {
          continue;
        }

        const cardRect = card.getBoundingClientRect();

        const cardStart = rtl
          ? cardRect.right
          : cardRect.left;

        const distance = Math.abs(
          cardStart - sliderStart
        );

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestPage = pageIndex;
        }
      }

      if (nearestPage !== currentPage) {
        currentPage = nearestPage;
        updateControls();
      }

      scrollTicking = false;
    }

    function rebuildSlider() {
      const previousCardsPerPage = cardsPerPage;

      cardsPerPage = calculateCardsPerPage();

      totalPages = Math.max(
        1,
        Math.ceil(cards.length / cardsPerPage)
      );

      if (previousCardsPerPage !== cardsPerPage) {
        currentPage = Math.min(
          currentPage,
          totalPages - 1
        );
      }

      createDots();
      updateControls();

      window.requestAnimationFrame(function () {
        goToPage(currentPage, 'auto');
      });
    }

    previousButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goToPage(currentPage - 1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goToPage(currentPage + 1);
      });
    });

    slider.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) {
          return;
        }

        scrollTicking = true;

        window.requestAnimationFrame(
          detectCurrentPage
        );
      },
      {
        passive: true
      }
    );

    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();

        if (isRTL()) {
          goToPage(currentPage + 1);
        } else {
          goToPage(currentPage - 1);
        }
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();

        if (isRTL()) {
          goToPage(currentPage - 1);
        } else {
          goToPage(currentPage + 1);
        }
      }
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(
        rebuildSlider,
        150
      );
    });

    rebuildSlider();
  }

  function initializeAllCollectionSliders(root) {
    const scope = root || document;

    scope
      .querySelectorAll('[data-pcs-section]')
      .forEach(initializeCollectionSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAllCollectionSliders(document);
      }
    );
  } else {
    initializeAllCollectionSliders(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllCollectionSliders(event.target);
    }
  );
})();